
export default {
  name: 'FlexBlok',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
